import { render } from "./Home.vue?vue&type=template&id=8c94edfa"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=8c94edfa&lang=less"

import exportComponent from "F:\\历史资料\\合肥商城\\povertyalleviation\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__